<mat-form-field appearance="outline">
  <mat-label>{{ label() }}</mat-label>
  <mat-select [formControl]="formControl" [placeholder]="label()" [multiple]="multiple()">
    @for (option of options(); track option.id) {
      <mat-option [value]="option.id">
        {{ option.description }}
      </mat-option>
    }
  </mat-select>
</mat-form-field>
